export const mergeProsemirrorConfigs = (configDerivedFromFE, configDerivedFromBE) => Object.assign({}, configDerivedFromFE, configDerivedFromBE);